const BASE = process.env.REACT_APP_BACKEND_URL;

async function postJson(path, body, token, fallbackMessage) {
  const resp = await fetch(`${BASE}/${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });
  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    throw new Error(err.error || fallbackMessage);
  }
  return resp.json();
}

/** All participants for a theme: [{ id, first_name, last_name, email_id }]. */
export async function listParticipants({ themeName, token }) {
  const data = await postJson(
    "listParticipants",
    { themename: themeName },
    token,
    "Failed to load participants"
  );
  return data.participants || [];
}

/** Add or edit one participant, mirroring old/admin/add-participants-upload.php. */
export async function saveParticipant({ themeName, token, action, editId, participant }) {
  return postJson(
    "saveParticipant",
    {
      themename: themeName,
      action,
      edit_id: editId || undefined,
      first_name: participant.first_name,
      last_name: participant.last_name,
      email_id: participant.email_id,
    },
    token,
    "Failed to save participant"
  );
}

export async function deleteParticipant({ themeName, id, token }) {
  return postJson(
    "deleteParticipant",
    { themename: themeName, id },
    token,
    "Failed to delete participant"
  );
}

/** Replaces every participant for the theme (old/admin/process_participants.php). */
export async function importParticipantsCsv({ themeName, rows, token }) {
  return postJson(
    "importParticipantsCsv",
    { themename: themeName, rows },
    token,
    "Failed to import CSV"
  );
}
